import {
  MobileOutlined,
  SafetyOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";
import BadgeIcon from "../assets/images/vectors/BadgeIcon";
import CredentialInvitationIcon from "../assets/images/vectors/CredentialInvitationIcon";
import DWIcon from "../assets/images/vectors/DWIcon";
import FarpointeMobileIcon from "../assets/images/vectors/FarpointeMobileIcon";
import GeminiIcon from "../assets/images/vectors/GeminiIcon";
import LogApiIcon from "../assets/images/vectors/LogApiIcon";
import MobileAppIcon from "../assets/images/vectors/MobileAppIcon";
import RestApiIcon from "../assets/images/vectors/RestApiIcon";
import SicunetMobileIcon from "../assets/images/vectors/SicunetMobileIcon";
import SpecoIcon from "../assets/images/vectors/SpecoIcon";
import SSOIcon from "../assets/images/vectors/SSOIcon";
import ThumbDriveIcon from "../assets/images/vectors/ThumbDriveIcon";
import VisitorInvitationIcon from "../assets/images/vectors/VisitorInvitationIcon";
import VitekIcon from "../assets/images/vectors/VitekIcon";
import WavelynxMobileIcon from "../assets/images/vectors/WavelynxMobileIcon";
import LocksetIcon from "../assets/images/vectors/LocksetIcon";
import TrilogyIcon from "../assets/images/vectors/TrilogyIcon";
import FacegateIcon from "../assets/images/vectors/FacegateIcon";
import OSDPIcon from "../assets/images/vectors/OSDPIcon";
import DirectoryIcon from "../assets/images/vectors/DirectoryIcon";
import IntercomIcon from "../assets/images/vectors/IntercomIcon";
import LicenseTypeIcon from "../assets/images/vectors/LicenseTypeIcon";
import SiteTypeIcon from "../assets/images/vectors/SiteTypeIcon";
import ProductIcon from "../assets/images/vectors/ProductIcon";

export const siteTypeOptions = [
  {
    value: 0,
    label: "On Premise",
  },
  {
    value: 1,
    label: "RMC",
  },
  {
    value: 2,
    label: "RMC Plus",
  },
  {
    value: 3,
    label: "Cloud",
  },
  {
    value: 4,
    label: "Virtual",
  },
];
export const booleanOptions = [
  {
    value: 1,
    label: "Yes",
  },
  {
    value: 0,
    label: "No",
  },
];

/** Plate form: AccessType selector (numeric values from access control product types). */
export const plateAccessTypeOptions = [
  { value: 2, label: "Door" },
  { value: 12, label: "Lockset" },
  // { value: 13, label: "Facegate" },
  { value: 17, label: "Trilogy Lockset" },
  // { value: 18, label: "Intercom" },
];

/** Plate Access Item modal — populate when API/options are available. */
export const plateAccessItemOptions = [];

export const nodeTypeOptions = [
  {
    value: 1,
    label: "Server Node",
  },
  {
    value: 2,
    label: "Client Node",
  },
];
export const productOptions = [
  {
    value: 0,
    label: "0 Door",
  },
  {
    value: 1,
    label: "1 Door",
  },
  {
    value: 2,
    label: "2 Door",
  },
  {
    value: 4,
    label: "4 Door",
  },
  {
    value: 8,
    label: "8 Door",
  },
];
export const modelOptions = [
  {
    value: 0,
    label: "Advantage",
  },
  {
    value: 1,
    label: "Professional",
  },
  {
    value: 2,
    label: "Corporate",
  },
];

export const licenseOptions = [
  {
    value: 1,
    label: "REST API",
  },
  {
    value: 2,
    label: "Log API",
  },
  {
    value: 3,
    label: "Gemini",
  },
  {
    value: 4,
    label: "Mobile App",
  },
  {
    value: 5,
    label: "Credential Invitation",
  },
  {
    value: 6,
    label: "Visitor Invitation",
  },
  {
    value: 7,
    label: "Single Sign On",
  },
  {
    value: 8,
    label: "Badge",
  },
  {
    value: 33,
    label: "Thumb Drive NVR",
  },
  {
    value: 34,
    label: "DW Spectrum",
  },
  {
    value: 35,
    label: "Speco NVR",
  },
  {
    value: 36,
    label: "Vitek NVR",
  },
  {
    value: 41,
    label: "Sicunet Mobile",
  },
  {
    value: 42,
    label: "Wavelynx Mobile",
  },
  {
    value: 43,
    label: "Farpointe Mobile",
  },
  {
    value: 64,
    label: "Expired",
  },
];
export const deviceOptions = [
  {
    value: 193,
    label: "Channel",
  },
  {
    value: 194,
    label: "Lockset",
  },
  {
    value: 195,
    label: "Facegate",
  },
  {
    value: 196,
    label: "OSDP Door",
  },
  {
    value: 197,
    label: "Trilogy Lockset",
  },
  {
    value: 198,
    label: "Intercom",
  },
  {
    value: 199,
    label: "Directory",
  },
  {
    value: 200,
    label: "Invitation",
  },
];
export const itemOptions = [
  {
    value: 1,
    label: "Site Type",
  },
  {
    value: 2,
    label: "Model",
  },
  {
    value: 3,
    label: "Door",
  },
  {
    value: 101,
    label: "Rest API",
  },
  {
    value: 102,
    label: "Log API",
  },
  {
    value: 103,
    label: "Gemini",
  },
  {
    value: 104,
    label: "Mobile App",
  },
  {
    value: 105,
    label: "Credential Invitation",
  },
  {
    value: 106,
    label: "Visitor Invitation",
  },
  {
    value: 107,
    label: "Single Sign On",
  },
  {
    value: 108,
    label: "Badge",
  },
  {
    value: 202,
    label: "Channel",
  },
  {
    value: 203,
    label: "Lockset",
  },
  {
    value: 204,
    label: "Facegate",
  },
  {
    value: 205,
    label: "OSDP Door",
  },
  {
    value: 206,
    label: "Trilogy Lockset",
  },
  {
    value: 207,
    label: "Intercom",
  },
  {
    value: 208,
    label: "Directory",
  },
  {
    value: 209,
    label: "Mobile Credential",
  },
];

export const findOptionLabel = (options, value) => {
  const matchedOption = options.find((item) => item.value === Number(value));
  if (matchedOption) {
    return matchedOption?.label;
  } else {
    return null;
  }
};

export const orderTypeOptions = [
  { label: "Monthly", value: 0 },
  { label: "Lifetime", value: 1 },
];

export const orderLicenseTypeOptions = [
  { label: "Monthly", value: 0 },
  { label: "Lifetime", value: 1 },
];

export const orderPayTypeOptions = [
  { label: "Invoice (Monthly)", value: 0 },
  { label: "Credit Card (Transaction)", value: 1 },
  { label: "Prepurchased License", value: 2 },
  { label: "Free (Not Activate)", value: 3 },
];

export const doorpricingTiers = [
  { max: 4, code: 4 },
  { max: 8, code: 8 },
  { max: 16, code: 16 },
  { max: 32, code: 32 },
  { max: 64, code: 64 },
  { max: 128, code: 128 },
  { max: 255, code: 256 },
  { max: 512, code: 512 },
  { max: 1024, code: 1024 },
  { max: 65535, code: 65535 },
];

export const pricingTiers = {
  202: [
    // Channel
    { max: 4, code: 4 },
    { max: 8, code: 8 },
    { max: 16, code: 16 },
    { max: 32, code: 32 },
    { max: 64, code: 64 },
    { max: 128, code: 128 },
    { max: 255, code: 255 },
  ],
  203: [
    // Lockset
    { max: 4, code: 4 },
    { max: 8, code: 8 },
    { max: 16, code: 16 },
    { max: 32, code: 32 },
    { max: 64, code: 64 },
    { max: 128, code: 128 },
    { max: 255, code: 255 },
  ],
  208: [
    // Directory Extension (0–65535, per-unit pricing like Lockset / door tiers)
    { max: 4, code: 4 },
    { max: 8, code: 8 },
    { max: 16, code: 16 },
    { max: 32, code: 32 },
    { max: 64, code: 64 },
    { max: 128, code: 128 },
    { max: 255, code: 256 },
    { max: 512, code: 512 },
    { max: 1024, code: 1024 },
    { max: 65535, code: 65535 },
  ],
  209: [
    // Mobile Credential
    { max: 400, code: 4 },
    { max: 800, code: 8 },
    { max: 1600, code: 16 },
    { max: 3200, code: 32 },
    { max: 6400, code: 64 },
    { max: 12800, code: 128 },
    { max: 25500, code: 255 },
  ],
  204: [
    // Facegate
    { max: 4, code: 4 },
    { max: 8, code: 8 },
    { max: 16, code: 16 },
    { max: 32, code: 32 },
    { max: 64, code: 64 },
    { max: 128, code: 128 },
    { max: 255, code: 255 },
  ],
  205: [
    // OSDP Device
    { max: 4, code: 4 },
    { max: 8, code: 8 },
    { max: 16, code: 16 },
    { max: 32, code: 32 },
    { max: 64, code: 64 },
    { max: 128, code: 128 },
    { max: 255, code: 255 },
  ],
  206: [
    // Trilogy Lockset
    { max: 4, code: 4 },
    { max: 8, code: 8 },
    { max: 16, code: 16 },
    { max: 32, code: 32 },
    { max: 64, code: 64 },
    { max: 128, code: 128 },
    { max: 255, code: 255 },
  ],
  207: [
    // Intercom
    { max: 4, code: 4 },
    { max: 8, code: 8 },
    { max: 16, code: 16 },
    { max: 32, code: 32 },
    { max: 64, code: 64 },
    { max: 128, code: 128 },
    { max: 255, code: 255 },
  ],
};

export const toggleCardOptions = [
  { value: 1, name: "Site Type" },
  { value: 2, name: "Model" },
  { value: 3, name: "Door" },
  { value: 101, name: "REST API" },
  { value: 102, name: "Log API" },
  { value: 103, name: "Gemini" },
  { value: 104, name: "Mobile App" },
  { value: 105, name: "Credential Invitation" },
  { value: 106, name: "Visitor Invitation" },
  { value: 107, name: "Single Sign On" },
  { value: 108, name: "Badge" },
];

export const inputCardOptions = [
  {
    label: "Channel",
    fieldName: "Channel",
    itemNo: 202, // Add this
    defaultValue: 0,
    max: 255,
    min: 0,
    step: 1,
    prefix: "$",
  },
  {
    label: "Lockset",
    fieldName: "Lockset",
    itemNo: 203, // Add this
    defaultValue: 0,
    max: 255,
    min: 0,
    step: 1,
    prefix: "$",
  },
  {
    label: "Facegate",
    fieldName: "Facegate",
    itemNo: 204, // Add this
    defaultValue: 0,
    max: 255,
    min: 0,
    step: 1,
    prefix: "$",
  },
  {
    label: "OSDP Door",
    fieldName: "Subnode",
    itemNo: 205, // Add this
    defaultValue: 0,
    max: 255,
    min: 0,
    step: 1,
    prefix: "$",
  },

  {
    label: "Trilogy Lockset",
    fieldName: "ContLock",
    itemNo: 206, // Add this
    defaultValue: 0,
    max: 255,
    min: 0,
    step: 1,
    prefix: "$",
  },
  {
    label: "Intercom",
    fieldName: "Intercom",
    itemNo: 207, // Add this
    defaultValue: 0,
    max: 255,
    min: 0,
    step: 1,
    prefix: "$",
  },
  {
    label: "Directory Extension",
    fieldName: "Sicucom",
    itemNo: 208,
    defaultValue: 0,
    max: 65535,
    min: 0,
    step: 1,
    prefix: "$",
  },
  {
    label: "Mobile Credential",
    fieldName: "Invitation",
    itemNo: 209, // Add this
    defaultValue: 0,
    max: 25500,
    min: 0,
    step: 100,
    prefix: "$",
  },
];

// Icon mapping for different option types
export const iconMap = {
  "REST API": <RestApiIcon />,
  "Log API": <LogApiIcon />,
  Gemini: <GeminiIcon />,
  "Mobile App": <MobileAppIcon />,
  "Credential Invitation": <CredentialInvitationIcon />,
  "Visitor Invitation": <VisitorInvitationIcon />,
  "Single Sign On": <SSOIcon />,
  Badge: <BadgeIcon />,
  "Thumb Drive NVR": <ThumbDriveIcon />,
  "DW Spectrum": <DWIcon />,
  "Speco NVR": <SpecoIcon />,
  "Vitek NVR": <VitekIcon />,
  "Sicunet Mobile": <SicunetMobileIcon />,
  "Wavelynx Mobile": <WavelynxMobileIcon />,
  "Farpointe Mobile": <FarpointeMobileIcon />,
  Expired: <SafetyOutlined style={{ fontSize: "18px" }} />,
  // Input card icons (can be customized)
  Channel: <VideoCameraOutlined style={{ fontSize: "18px" }} />,
  Lockset: <LocksetIcon />,
  "ALLEGION Lockset": <SafetyOutlined style={{ fontSize: "18px" }} />,
  "Trilogy Lockset": <TrilogyIcon />,
  Facegate: <FacegateIcon />,
  "OSDP Door": <OSDPIcon />,
  // Backward compatibility: old label may still exist in legacy payload/state.
  "OSDP Device": <OSDPIcon />,
  Intercom: <IntercomIcon />,
  "Directory Extension": <DirectoryIcon />,
  "Mobile Credential": <MobileOutlined style={{ fontSize: "18px" }} />,
};

export const modelIconMap = {
  0: <LicenseTypeIcon />,
  1: <LicenseTypeIcon />,
  2: <LicenseTypeIcon />,
};

export const siteTypeIconMap = {
  0: <SiteTypeIcon />,
  1: <SiteTypeIcon />,
  2: <SiteTypeIcon />,
  3: <SiteTypeIcon />,
  4: <SiteTypeIcon />,
};
export const productIconMap = {
  0: <ProductIcon />,
  1: <ProductIcon />,
  2: <ProductIcon />,
  4: <ProductIcon />,
  8: <ProductIcon />,
};

export const hidePriceLabels = [
  "Sicunet Mobile",
  "Wavelynx Mobile",
  "Farpointe Mobile",
  "Vitek NVR",
  "Speco NVR",
  "DW Spectrum",
  "Thumb Drive NVR",
];

export const calculateTotals = (
  licenseOptionsData,
  licenseTypePrice,
  doorPrice,
  siteTypePrice = 0,
) => {
  let optionsTotal = 0;
  Object.entries(licenseOptionsData).forEach(([key, val]) => {
    if (!hidePriceLabels.includes(key)) {
      optionsTotal += val.price || 0;
    }
  });

  const total = licenseTypePrice + doorPrice + optionsTotal + siteTypePrice;
  return total.toFixed(2);
};

export const getItemNoByLabel = (label) => {
  const normalizedLabel = label === "OSDP Device" ? "OSDP Door" : label;
  // First check in toggleCardOptions
  const toggleOption = toggleCardOptions.find(
    (item) => item.name === normalizedLabel,
  );
  if (toggleOption) return toggleOption.value;
  const inputOption = inputCardOptions.find(
    (item) => item.label === normalizedLabel,
  );
  if (inputOption) return inputOption.itemNo;

  return null;
};

/**
 * Resolve gift card row (Item + CodeName/Code) to the value to send to backend.
 * Uses codesData first, then falls back to Common option lists (siteTypeOptions, modelOptions, productOptions).
 */
export const getCodeValueForGiftCard = (itemNo, codeName, code, codesData) => {
  if (codesData?.data) {
    let codeItem = codesData.data.find(
      (item) => item.Item === itemNo && item.CodeName === codeName,
    );
    if (!codeItem) {
      codeItem = codesData.data.find(
        (item) => item.Item === itemNo && item.Code === code,
      );
    }
    if (codeItem != null) return codeItem.Code;
  }
  if (itemNo === 1) {
    const opt = siteTypeOptions.find((o) => o.label === codeName);
    return opt != null ? opt.value : code;
  }
  if (itemNo === 2) {
    const opt = modelOptions.find((o) => o.label === codeName);
    return opt != null ? opt.value : code;
  }
  if (itemNo === 3) {
    const opt = productOptions.find((o) => o.label === codeName);
    return opt != null ? opt.value : code;
  }
  return code;
};

/**
 * Human-readable label for a stored code value (Item 1–3 / inputs use codesData.CodeName when present).
 */
export const getGiftCardCodeDisplayLabel = (itemNo, codeValue, codesData) => {
  const n = Number(codeValue);
  if (!Number.isFinite(n)) {
    return codeValue != null && codeValue !== "" ? String(codeValue) : "";
  }

  if (codesData?.data) {
    const codeItem = codesData.data.find(
      (item) => item.Item === itemNo && Number(item.Code) === n,
    );
    if (codeItem?.CodeName != null && String(codeItem.CodeName).trim() !== "") {
      return String(codeItem.CodeName).trim();
    }
  }
  if (itemNo === 1) {
    const opt = siteTypeOptions.find((o) => Number(o.value) === n);
    if (opt) return opt.label;
  }
  if (itemNo === 2) {
    const opt = modelOptions.find((o) => Number(o.value) === n);
    if (opt) return opt.label;
  }
  if (itemNo === 3) {
    const opt = productOptions.find((o) => Number(o.value) === n);
    if (opt) return opt.label;
  }
  return String(n);
};

const doorDisplayPhrase = (text) => {
  const s = String(text ?? "").trim();
  if (s === "") return s;
  if (/^\d+$/.test(s)) return `${s} Door`;
  return s;
};

const GIFT_CARD_LEGACY_INPUT_ITEM_MAP = {
  193: 202,
  194: 203,
  195: 204,
  196: 205,
  197: 206,
  198: 207,
  199: 208,
  200: 209,
};

const resolveGiftCardInputItemNo = (licenseItem) => {
  const n = Number(licenseItem);
  if (Number.isNaN(n)) return null;
  if (inputCardOptions.some((o) => o.itemNo === n)) return n;
  return GIFT_CARD_LEGACY_INPUT_ITEM_MAP[n] ?? null;
};

/**
 * When Channel / Mobile Credential quantities are set, mirror site PUT behavior:
 * include child NVR / mobile option ids in Options.
 */
export const enrichGiftCardOptionsWithChannelMobileChildren = (
  optionsArray,
  channelVal,
  invitationVal,
) => {
  const out = [...optionsArray];
  const channelChildOptionValues = [33, 34, 35, 36];
  const mobileCredChildOptionValues = [41, 42, 43];
  /** License Options value for "Credential Invitation" toggle (parent of Mobile Credential qty). */
  const CREDENTIAL_INVITATION_OPTION = 5;
  const ch = Number(channelVal) || 0;
  const inv = Number(invitationVal) || 0;
  if (ch > 0) {
    channelChildOptionValues.forEach((v) => {
      if (!out.includes(v)) out.push(v);
    });
  }
  if (inv > 0) {
    if (!out.includes(CREDENTIAL_INVITATION_OPTION)) {
      out.push(CREDENTIAL_INVITATION_OPTION);
    }
    mobileCredChildOptionValues.forEach((v) => {
      if (!out.includes(v)) out.push(v);
    });
  }
  return out;
};

export const resolveLicenseTypeFromSiteType = (
  siteTypeValue,
  orderTypeOpts,
) => {
  const st = Number(siteTypeValue);
  if ([0, 1, 2].includes(st)) return orderTypeOpts[1].value;
  if ([3, 4].includes(st)) return orderTypeOpts[0].value;
  return undefined;
};

/**
 * Prepurchased / gift rows may include GiftCardItems: { LicenseItem, LicenseItemLabel, NewCode }[].
 * Last row wins per LicenseItem. Core 1–3 → SiteType / Model / Type; 101–108 → Options; inputs → form fields.
 */
export const mergeGiftCardItemsState = (giftCardItems, codesData) => {
  if (!Array.isArray(giftCardItems) || giftCardItems.length === 0) {
    return null;
  }

  const core = new Map();
  const toggles = new Map();
  const inputs = new Map();

  for (const row of giftCardItems) {
    const lic = Number(row.LicenseItem);
    if (Number.isNaN(lic)) continue;
    const nc = row.NewCode;
    const label = row.LicenseItemLabel;
    if (lic >= 1 && lic <= 3) {
      core.set(lic, { label, code: nc });
    } else if (lic >= 101 && lic <= 108) {
      toggles.set(lic, nc);
    } else {
      inputs.set(lic, { label, code: nc });
    }
  }

  const formPatch = {};

  if (core.has(1)) {
    const { label, code } = core.get(1);
    formPatch.SiteType = getCodeValueForGiftCard(1, label, code, codesData);
  }
  if (core.has(2)) {
    const { label, code } = core.get(2);
    formPatch.Model = getCodeValueForGiftCard(2, label, code, codesData);
  }
  if (core.has(3)) {
    const { label, code } = core.get(3);
    formPatch.Type = getCodeValueForGiftCard(3, label, code, codesData);
  }

  const optionsArray = [];
  for (const [lic, nc] of toggles) {
    const n = Number(nc);
    if (!Number.isNaN(n) && n !== 0) {
      optionsArray.push(lic - 100);
    }
  }

  for (const [lic, { label, code }] of inputs) {
    const resolvedItemNo = resolveGiftCardInputItemNo(lic);
    if (resolvedItemNo == null) continue;
    const meta = inputCardOptions.find((o) => o.itemNo === resolvedItemNo);
    if (!meta) continue;
    const codeValue = getCodeValueForGiftCard(
      resolvedItemNo,
      label,
      code,
      codesData,
    );
    const isInvitationHundredths = meta.fieldName === "Invitation";
    formPatch[meta.fieldName] = isInvitationHundredths
      ? Number(codeValue) * 100
      : Number(codeValue);
  }

  return { formPatch, optionsArray };
};

const parseFormOptionsToNumbers = (options) => {
  if (options == null) return [];
  const arr = Array.isArray(options) ? options : [];
  return arr.map((x) => Number(x)).filter((n) => !Number.isNaN(n));
};

/**
 * When a prepurchased row has both OldCode and NewCode, the site’s current
 * value for that license line must match OldCode before applying NewCode.
 * Rows with OldCode null skip this check (direct upgrade from NewCode).
 * Quantity inputs (Channel, Lockset, Directory, etc.): if the site has no
 * value or 0, OldCode is not enforced so NewCode applies without that error.
 */
export const validateGiftCardItemsOldCodeMatchesForm = (
  giftCardItems,
  codesData,
  formValues,
) => {
  if (!Array.isArray(giftCardItems) || giftCardItems.length === 0) {
    return { ok: true };
  }

  const byLic = new Map();
  for (const row of giftCardItems) {
    const lic = Number(row.LicenseItem);
    if (Number.isNaN(lic)) continue;
    byLic.set(lic, row);
  }

  const optionsOnForm = parseFormOptionsToNumbers(formValues?.Options);

  for (const row of byLic.values()) {
    const oldC = row.OldCode;
    const newC = row.NewCode;
    const oldPresent = oldC != null && oldC !== "";
    const newPresent = newC != null && newC !== "";
    if (!oldPresent || !newPresent) {
      continue;
    }

    const lic = Number(row.LicenseItem);
    const label = row.LicenseItemLabel ?? "";

    if (lic >= 1 && lic <= 3) {
      const expected = Number(
        getCodeValueForGiftCard(lic, label, oldC, codesData),
      );
      const field = lic === 1 ? "SiteType" : lic === 2 ? "Model" : "Type";
      const actual = Number(formValues[field]);
      if (!Number.isFinite(expected)) {
        continue;
      }
      if (!Number.isFinite(actual) || expected !== actual) {
        const expLabel = getGiftCardCodeDisplayLabel(lic, expected, codesData);
        const actLabel = Number.isFinite(actual)
          ? getGiftCardCodeDisplayLabel(lic, actual, codesData)
          : "";
        let message;
        if (lic === 1) {
          const siteClause =
            actLabel !== ""
              ? `site has ${actLabel} site type`
              : "site has no site type";
          message = `Cannot apply this prepurchased license: ${expLabel} site type, ${siteClause}.`;
        } else if (lic === 2) {
          const siteClause =
            actLabel !== ""
              ? `site has ${actLabel} Model`
              : "site has no Model";
          message = `Cannot apply this prepurchased license: ${expLabel} Model, ${siteClause}.`;
        } else {
          const expPhrase = doorDisplayPhrase(expLabel);
          const siteClause =
            actLabel !== ""
              ? `site has ${doorDisplayPhrase(actLabel)}`
              : "site has no Door";
          message = `Cannot apply this prepurchased license: ${expPhrase}, ${siteClause}.`;
        }
        return { ok: false, message };
      }
    } else if (lic >= 101 && lic <= 108) {
      const optNum = lic - 100;
      const expectedOn = Number(oldC) !== 0 && !Number.isNaN(Number(oldC));
      const actualOn = optionsOnForm.includes(optNum);
      if (expectedOn !== actualOn) {
        const name = label || "this option";
        return {
          ok: false,
          message: `Cannot apply this prepurchased license: requires ${name} ${expectedOn ? "on" : "off"}, site has ${actualOn ? "on" : "off"}.`,
        };
      }
    } else {
      const resolvedItemNo = resolveGiftCardInputItemNo(lic);
      if (resolvedItemNo == null) continue;
      const meta = inputCardOptions.find((o) => o.itemNo === resolvedItemNo);
      if (!meta) continue;
      const resolvedOld = getCodeValueForGiftCard(
        resolvedItemNo,
        label,
        oldC,
        codesData,
      );
      const expectedForm =
        meta.fieldName === "Invitation"
          ? Number(resolvedOld) * 100
          : Number(resolvedOld);
      const actualForm = Number(formValues[meta.fieldName]);
      if (!Number.isFinite(expectedForm)) {
        continue;
      }
      if (
        !Number.isFinite(actualForm) ||
        Math.round(expectedForm) !== Math.round(actualForm)
      ) {
        const actualRounded = Number.isFinite(actualForm)
          ? Math.round(actualForm)
          : NaN;
        if (!Number.isFinite(actualForm) || actualRounded === 0) {
          continue;
        }
        const partName = meta.label || meta.fieldName;
        const expDisplay =
          meta.fieldName === "Invitation"
            ? Math.round(Number(resolvedOld))
            : Math.round(expectedForm);
        const actDisplay =
          meta.fieldName === "Invitation"
            ? Number.isFinite(actualForm)
              ? Math.round(actualForm / 100)
              : null
            : Number.isFinite(actualForm)
              ? Math.round(actualForm)
              : null;
        const siteClause =
          actDisplay != null
            ? `site has ${actDisplay} ${partName}`
            : `site has no ${partName}`;
        return {
          ok: false,
          message: `Cannot apply this prepurchased license: ${expDisplay} ${partName}, ${siteClause}.`,
        };
      }
    }
  }

  return { ok: true };
};

export const getPriceByItemNo = (itemNo, tierCode, codesData, type) => {
  if (!codesData?.data) {
    return 0;
  }

  let codeItem;

  if (tierCode) {
    // First, try to find with constructed codeName: "Door-4", "Channel-8", etc.
    const baseItem = codesData.data.find((item) => item.Item === itemNo);

    if (baseItem) {
      const constructedCodeName = `${baseItem.CodeName}-${tierCode}`;

      codeItem = codesData.data.find(
        (item) => item.Item === itemNo && item.CodeName === constructedCodeName,
      );
    }

    // If not found with constructed name, try matching by Item and Code directly
    if (!codeItem) {
      codeItem = codesData.data.find(
        (item) => item.Item === itemNo && item.Code === tierCode,
      );
    }
  } else {
    // For non-tiered items (toggles), just match by Item
    codeItem = codesData.data.find((item) => item.Item === itemNo);
  }

  if (!codeItem) {
    return 0;
  }

  const price =
    type === 0 ? parseFloat(codeItem.Monthly) : parseFloat(codeItem.Lifetime);

  return price || 0;
};

export const getPrice = (
  itemLabel,
  codesData,
  type,
  quantity = 1,
  itemNo = null,
) => {
  // Get itemNo if not provided
  if (!itemNo) {
    itemNo = getItemNoByLabel(itemLabel);
  }

  // Use itemNo as lookup key
  const lookupKey = itemNo || itemLabel;

  if (pricingTiers[lookupKey]) {
    const tiers = pricingTiers[lookupKey];
    let totalPrice = 0;
    let remainingQuantity = quantity;
    let previousMax = 0;

    // Mobile Credential (209): UI quantity is in hundredths vs tier units
    const isDividedBy100 = itemNo === 209;

    for (const tier of tiers) {
      if (remainingQuantity <= 0) break;

      const tierCapacity = tier.max - previousMax;
      const unitsInThisTier = Math.min(remainingQuantity, tierCapacity);

      // Pass itemNo and tier.code (not tier.codeName)
      const tierPrice = getPriceByItemNo(itemNo, tier.code, codesData, type);

      if (isDividedBy100) {
        totalPrice += (unitsInThisTier / 100) * tierPrice;
      } else {
        totalPrice += unitsInThisTier * tierPrice;
      }

      remainingQuantity -= unitsInThisTier;
      previousMax = tier.max;
    }

    return totalPrice;
  } else {
    // For non-tiered items (like toggles), just pass the itemNo without tier code
    return getPriceByItemNo(itemNo, null, codesData, type);
  }
};

export const calculateLicenseTypePrice = (
  modelValue,
  licenseType,
  codesData,
  modifiedModelsOptions,
) => {
  if (!codesData?.data) return 0;

  // Find the model name from modifiedModelsOptions
  const selectedModel = modifiedModelsOptions.find(
    (model) => model.value === modelValue,
  );

  if (!selectedModel) return 0;

  // Map model labels to CodeName
  const modelCodeNameMap = {
    Advantage: "Advantage",
    Professional: "Professional",
    Corporate: "Corporate",
  };

  const codeName = modelCodeNameMap[selectedModel.label];
  if (!codeName) return 0;

  // Find the code item
  const codeItem = codesData.data.find((item) => item.CodeName === codeName);

  if (!codeItem) return 0;

  // Get price based on license type (0 = Monthly, 1 = Lifetime)
  const price =
    licenseType === 0
      ? parseFloat(codeItem.Monthly)
      : parseFloat(codeItem.Lifetime);

  return price;
};

export const calculateSiteTypePrice = (
  siteTypeValue,
  licenseType,
  codesData,
) => {
  if (!codesData?.data) return 0;

  // Map site type values to CodeName
  const siteTypeCodeNameMap = {
    0: "On Premise",
    1: "RMC",
    2: "RMC PLUS",
    3: "Cloud",
    4: "Virtual",
  };

  const codeName = siteTypeCodeNameMap[siteTypeValue];
  if (!codeName) return 0;

  // Find the code item with Item: 1 and matching CodeName
  const codeItem = codesData.data.find(
    (item) => item.Item === 1 && item.CodeName === codeName,
  );

  if (!codeItem) return 0;

  // Get price based on license type (0 = Monthly, 1 = Lifetime)
  const price =
    licenseType === 0
      ? parseFloat(codeItem.Monthly)
      : parseFloat(codeItem.Lifetime);

  return price || 0;
};

export const calculateDoorPrice = (doorCount, licenseType, codesData) => {
  if (!doorCount || doorCount <= 0) return 0;
  if (!codesData?.data) return 0;

  const DOOR_ITEM_NO = 3;
  let totalPrice = 0;
  let remainingDoors = Number(doorCount);
  let previousMax = 0;

  for (const tier of doorpricingTiers) {
    if (remainingDoors <= 0) break;

    const tierCapacity = tier.max - previousMax;
    const doorsInThisTier = Math.min(remainingDoors, tierCapacity);

    // Use getPriceByItemNo with itemNo=3 and the tier code
    const tierPrice = getPriceByItemNo(
      DOOR_ITEM_NO, // itemNo = 3
      tier.code, // code = 4, 8, 16, etc.
      codesData,
      licenseType,
    );

    totalPrice += doorsInThisTier * tierPrice;

    remainingDoors -= doorsInThisTier;
    previousMax = tier.max;
  }

  return totalPrice;
};

export const billingTypeOptions = [
  { label: "Transaction", value: 1 },
  { label: "Monthly", value: 0 },
];
